import { Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-smart-dialog-result',
    templateUrl: './smart-dialog-result.component.html',
    styleUrls: ['./smart-dialog-result.component.scss']
})
export class SmartDialogResultComponent {
    @Input() loading = false;

    @Input() error = false;
    @Input() errorTitle = $localize`Error during import!`;
    @Input() errorMessage = $localize`Please contact our support.`;

    @Input() title = $localize`Import completed!`;
    @Input() successMessage = '';

    // Deprecated, too specific to employee import
    @Input() numberOfSuccessfulUploads = 0;
    @Input() successfulUploadsSuffix = $localize`elements have been uploaded.`;
}
